import $ from 'jquery';

const WorkStyle = function () {
  const $el = $('.js-workstyleSlider');
  $el.hide();
  $(window).on('load', function () {
    $el.show();
    // Slick Options
    $el.slick({
      // autoplay: true,
      dots: true,
      variableWidth: false,
      pauseOnFocus: false
    });
  });
}


export default WorkStyle;


// WEBPACK FOOTER //
// ./src/recruit/js/workStyle.js